import { useEffect, useRef, useState } from 'react';
import { Modal } from './Modal';
import { registerSelfApprovalPrompt } from '../api/client';

const MIN = 15;

/**
 * Mounted once at the app root. Opens when the server asks the designated
 * administrator for a written justification before deciding their own request
 * (VConnect 120). The justification is recorded in the audit trail.
 */
export function SelfApprovalPrompt() {
  const [message, setMessage] = useState<string | null>(null);
  const [text, setText] = useState('');
  const resolver = useRef<((v: string | null) => void) | null>(null);

  useEffect(() => {
    registerSelfApprovalPrompt((msg) => new Promise<string | null>((resolve) => {
      resolver.current = resolve;
      setText('');
      setMessage(msg);
    }));
    return () => registerSelfApprovalPrompt(null);
  }, []);

  const finish = (value: string | null) => {
    resolver.current?.(value);
    resolver.current = null;
    setMessage(null);
  };

  if (message === null) return null;
  const trimmed = text.trim();
  return (
    <Modal title="Justify self-approval" onClose={() => finish(null)}>
      <p>{message}</p>
      <p className="muted">Your justification is stored permanently in the audit trail with this decision.</p>
      <textarea
        autoFocus
        rows={4}
        style={{ width: '100%' }}
        value={text}
        maxLength={1000}
        onChange={(e) => setText(e.target.value)}
        placeholder="Why are you deciding your own request instead of an independent approver?"
      />
      <div className="muted" style={{ fontSize: 12 }}>{trimmed.length < MIN ? `At least ${MIN} characters (${trimmed.length}/${MIN}).` : `${trimmed.length} characters.`}</div>
      <div className="modal-actions" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
        <button type="button" className="btn-secondary" onClick={() => finish(null)}>Cancel</button>
        <button type="button" className="btn-primary" disabled={trimmed.length < MIN} onClick={() => finish(trimmed)}>Record decision</button>
      </div>
    </Modal>
  );
}
